module.exports = __webpack_public_path__ + "static/media/vf_mknit_core.45464be3.svg";